// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d40abbe5","453":"6b93db4d"}[chunkId] + ".chunk.js";
};